import { IonItem } from "@ionic/react";
import { MdLaunch } from "react-icons/md";

import { EditableInput } from "~components/Atoms";

import { EditableFieldsBase } from "./types";

export const EditableLink: React.FC<EditableFieldsBase> = ({
  isEditing,
  lines,
  className,
  label,
  placeholder,
  value,
  onChange,
}) => {
  return isEditing ? (
    <IonItem className={className}>
      <EditableInput onChange={onChange} label={label} placeholder={placeholder} value={value} />
    </IonItem>
  ) : value ? (
    <IonItem lines={lines} className={className}>
      <a className="flex w-full items-center gap-4" href={value} target="_blank" rel="noreferrer">
        <MdLaunch className="icon-2xl" />
        {label}
      </a>
    </IonItem>
  ) : (
    <></>
  );
};
